import { Link, useNavigate } from "react-router-dom"
import styled from "styled-components"
const FooterBox = styled.div`
    background-color: ${(props) => props.theme.primary};
    /* border-top:thin solid gray; */
    padding-top: 1em;
    padding-bottom: 1em;
`
const FooterText = styled.div`
    color: ${(props) => props.theme.background};
    /* color:white; */
    text-align: center;
    vertical-align: text-middle;
    font-size: 1rem;
    font-family: Inter;
    border-style: hidden;
    outline: none;
`

export function Footer(): JSX.Element {
    const navigate = useNavigate()
    return (
        <>
            <div
                style={{
                    border: "1px",
                    backgroundColor: "white",
                    color: "blue",
                    height: "2em",
                    width: "5em",
                    textAlign: "center",
                }}
                onClick={() => navigate("/colorPalette")}
            >                
            </div>

            <FooterBox>
                <FooterText>17 Briden St, Worcester, MA 01605 · <a href="mailto:support@plabsequencing.com" style={{ color: "white" }}>Contact Us</a></FooterText>
                <FooterText>
                    © 2025 Pananosis Laboratories LLC · 
                    <Link style={{ color: "white" }} to="/terms"> Terms of Service · </Link>
                    <Link style={{ color: "white" }} to="/privacy">Privacy Policy</Link>
                </FooterText>

            </FooterBox>
        </>
    )
}
